module.exports = __webpack_public_path__ + "img/green-lagoon.781a3cf9.jpg";